import Big from 'big.js'
import { Caption, Column, IconCircle, Icons, Label, Opacities, Opacity, rem, Row, SizedBox } from '@collabhouse/shared'
import React, { type FunctionComponent } from 'react'

import { type CollaborationTerms } from '../../graphql/generated'
import { type Term } from '../../providers/CollaborationProvider.types'
import formatPercentage from '../../utils/formatPercentage'

interface Props {
  collaborationTerms: Pick<Term | CollaborationTerms, 'type' | 'fixedFee' | 'royaltySharePercentage'>
  noIcon?: boolean
}

const CollaborationPrice: FunctionComponent<React.PropsWithChildren<Props>> = ({ collaborationTerms, noIcon }) => {
  if (collaborationTerms.type === 'fixedFee') {
    return (
      <Row crossAxisAlignment="center">
        {!noIcon && (
          <>
            <Column>
              <IconCircle icon={Icons.dollar} iconSize="24px" />
            </Column>
            <SizedBox width={{ desktop: rem(16), mobile: rem(8) }} />
          </>
        )}

        <Column>
          <Label size="small">Fixed fee</Label>
          <Opacity opacity={Opacities.fiftyfive}>
            <Caption size="small">{`€ ${new Big(Number(collaborationTerms.fixedFee)).toString()}`}</Caption>
          </Opacity>
        </Column>
      </Row>
    )
  }
  return (
    <Row crossAxisAlignment="center">
      {!noIcon && (
        <>
          <Column>
            <IconCircle icon={Icons.percent} iconSize="24px" />
          </Column>
          <SizedBox width={{ desktop: rem(16), mobile: rem(8) }} />
        </>
      )}
      <Column>
        <Label size="small">Royalty split</Label>
        <Opacity opacity={Opacities.fiftyfive}>
          <Caption size="small">{formatPercentage(collaborationTerms.royaltySharePercentage)}</Caption>
        </Opacity>
      </Column>
    </Row>
  )
}

export default CollaborationPrice
